import { action, makeObservable, observable } from "mobx";
import { onValue, ref, set } from "firebase/database";
import { database } from "../../configs";
import { getUserId } from "../../helpers";

export default class Settings {
  mainStore;

  lang = null;
  data = null;
  isVideoTutorialInfoOpen = true;

  constructor(mainStore) {
    makeObservable(this, {
      data: observable,
      setData: action,
      lang: observable,
      setLang: action,
      isVideoTutorialInfoOpen: observable,
      setIsVideoTutorialInfoOpen: action,
    });

    this.mainStore = mainStore;
  }

  setLang(value) {
    this.lang = value;
  }

  async index() {
    const userId = await getUserId();
    const refValue = ref(database, `${userId}/Settings`);

    await onValue(refValue, (data) => {
      this.setData(data.val());
    });
  }

  async createUserSettings(userId, { phoneNumber, locale } = {}) {
    try {
      const data = {
        ...(phoneNumber && { phone_number: phoneNumber }),
        ...(locale && { locale }),
      };

      await set(ref(database, `${userId}/Settings`), data);
    } catch (error) {
      window.console.error("Error saving user settings:", error);
    }
  }

  setIsVideoTutorialInfoOpen(value) {
    this.isVideoTutorialInfoOpen = value;
  }

  setData(value) {
    this.data = value || null;
  }
}
